import React from "react";
import Text from "@/components/ui/text";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import { Info, Workflow } from "@dreamhub/designsystem/icons";
import { IconButton } from "@/components/ui/icon-button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

interface Props {
  title: React.ReactNode;
  description?: string | null;
  rightSlot?: React.ReactNode;
}

const WorkflowDetailPanelHeader: React.FC<Props> = ({
  title,
  description,
  rightSlot
}) => (
  <div className="p-4 flex items-center justify-between border-b border-border-border1">
    <div className="flex gap-4 items-center">
      <LogoIconContainer index={-1} className="size-8" icon={<Workflow />} />
      <Text
        variant="lgSubtitle"
        className="truncate max-w-[30vw]"
        hasTruncatedTooltip
      >
        {title}
      </Text>
      {description && (
        <Tooltip>
          <TooltipTrigger asChild>
            <IconButton
              variant="iconNoBg"
              iconColor="secondary"
              size="md"
              className="p-[2px]"
            >
              <Info />
            </IconButton>
          </TooltipTrigger>
          <TooltipContent className="max-w-md">
            <Text variant="smBody">{description}</Text>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
    {rightSlot && <div className="flex items-center gap-2">{rightSlot}</div>}
  </div>
);

export default WorkflowDetailPanelHeader;
